import React, { useState } from "react";
import { useLang } from "../i18n";
import { api } from "../api";
import { toast } from "sonner";

export default function Contact() {
  const { t, lang } = useLang();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/leads", { ...form, source: "contact", locale: lang });
      setDone(true);
      setForm({ name: "", email: "", phone: "", message: "" });
      toast.success(t.contact.sent);
    } catch (err) {
      toast.error(t.contact.error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="contact-page" className="bg-[#0F0F0F]">
      <section className="pt-36 md:pt-44 pb-16">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12">
          <div className="eyebrow mb-4">{t.contact.eyebrow}</div>
          <h1 className="font-serif text-5xl md:text-7xl text-[#F5F5F0] tracking-tight leading-[0.95] max-w-4xl">
            {t.contact.title}
          </h1>
          <p className="text-white/60 mt-8 max-w-lg">{t.contact.intro}</p>
        </div>
      </section>

      <section className="pb-32">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-16">
          <div className="md:col-span-7">
            {done ? (
              <div className="border border-[#D4AF37]/40 p-10 bg-[#141414]" data-testid="contact-success">
                <div className="font-serif text-[#D4AF37] text-2xl mb-3">—</div>
                <p className="font-serif text-2xl text-[#F5F5F0]">{t.contact.sent}</p>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-8" data-testid="contact-form">
                <input
                  required
                  placeholder={t.contact.name}
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className="input-line"
                  data-testid="contact-name"
                />
                <input
                  required
                  type="email"
                  placeholder={t.contact.email}
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  className="input-line"
                  data-testid="contact-email"
                />
                <input
                  placeholder={t.contact.phone}
                  value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })}
                  className="input-line"
                  data-testid="contact-phone"
                />
                <textarea
                  rows={5}
                  placeholder={t.contact.message}
                  value={form.message}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  className="input-line resize-none"
                  data-testid="contact-message"
                />
                <div className="pt-4">
                  <button type="submit" disabled={submitting} className="btn-gold disabled:opacity-50" data-testid="contact-submit">
                    {submitting ? "..." : t.cta.send}
                  </button>
                </div>
              </form>
            )}
          </div>

          <aside className="md:col-span-5 md:pl-8">
            <div className="border-l border-[#D4AF37]/30 pl-8 space-y-10">
              <div>
                <div className="eyebrow mb-3">{t.contact.office}</div>
                <address className="not-italic text-[#F5F5F0] leading-relaxed">
                  3310, 100e Avenue, bureau 340<br/>
                  Laval, Québec — H7T 0J7
                </address>
              </div>
              <div>
                <div className="eyebrow mb-3">{t.contact.phone_lbl}</div>
                <a href="tel:5145725507" className="block text-[#F5F5F0] hover:text-[#D4AF37] transition-colors">T: 514.572.5507</a>
                <a href="tel:5142747575" className="block text-[#F5F5F0] hover:text-[#D4AF37] transition-colors">B: 514.274.7575</a>
              </div>
              <div>
                <div className="eyebrow mb-3">{t.contact.email_lbl}</div>
                <a
                  href="mailto:contact@rolandazar-courtierimmobilier.com"
                  className="text-[#F5F5F0] hover:text-[#D4AF37] transition-colors break-all"
                >
                  contact@rolandazar-courtierimmobilier.com
                </a>
              </div>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
}
